
import {
  QueryClient,
  useQuery as useGet,
  useMutation as usePost,
  type QueryKey,


} from '@tanstack/react-query';

export const queryClient = new QueryClient();
type UseApiReturnType = {
  useQuery: typeof useGet;
  useMutate: typeof usePost;
  invalidateQuery: (queryKey: QueryKey) => void;
};

const useApi = (): UseApiReturnType => {
  const invalidateQuery = (queryKey: QueryKey) => {
    queryClient.invalidateQueries({ queryKey });
  };

  return {
    useQuery: useGet,
    useMutate: usePost,
    invalidateQuery,
  };
};

export default useApi;